import React from 'react'
import SkuMediaDropzone from '../SkuMediaDropzone'

const CSV_ACCEPT = '.csv,text/csv'

function pickCsvFile(files) {
  return files.filter((file) => file.name.toLowerCase().endsWith('.csv'))
}

function CsvDropzone({ onFileSelect, disabled }) {
  return (
    <SkuMediaDropzone
      accept={CSV_ACCEPT}
      browseKey="catalogue.skuMediaUpload.bulkDelete.dropzone.browse"
      disabled={disabled}
      dropzoneTestId="sku-media-csv-dropzone"
      filterFiles={pickCsvFile}
      hintKey="catalogue.skuMediaUpload.bulkDelete.dropzone.hint"
      inputTestId="sku-media-bulk-delete-csv"
      onFilesSelected={(files) => onFileSelect(files[0])}
      titleKey="catalogue.skuMediaUpload.bulkDelete.dropzone.title"
    />
  )
}

export default CsvDropzone
